export class TOSMac {

    ID: number;
    MemberID: number;
    AdminID: number;
    DateTimeCreated: Date;
    Ignore: boolean;
    Mac: string;

    static FixDate(item: TOSMac) {
        item.DateTimeCreated = new Date(item.DateTimeCreated);
    }

}

export class TOSMacArray extends Array<TOSMac>  {

    constructor(...items: TOSMac[]) {
        super(...items);
        Object.setPrototypeOf(this, TOSMacArray.prototype);
    }

    static FixDates(items: TOSMacArray) {
        items.forEach(x => { TOSMac.FixDate(x); });
    }

}
